export default function StudentPerformance(){
    return <h1>Student Performance</h1>
}